import axios from "axios";
import { getLocalToken, getHost, getHeaders, getAuthToken } from "./config";
import { refreshToken } from "../services/BasicAPIFunctions";
import { createRefreshCoordinator } from "./refreshCoordinator";

const loginPath = `${(process.env.PUBLIC_URL || "").replace(/\/$/, "")}/`;
let loginRedirectStarted = false;

const clearSessionAndShowLogin = () => {
  localStorage.clear();
  if (!loginRedirectStarted && window.location.pathname !== loginPath) {
    loginRedirectStarted = true;
    window.location.replace(loginPath);
  }
};

const getRefreshedAccessToken = createRefreshCoordinator(async () => {
  const refreshTokenValue = localStorage.getItem("refresh");
  if (!refreshTokenValue) {
    throw new Error("Refresh token is missing");
  }

  const response = await refreshToken({ refresh_token: refreshTokenValue });
  return response.data.response.access_token;
});

const axiosInstance = axios.create({
  baseURL: getHost(),
  headers: {},
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = getLocalToken();
    const authToken = getAuthToken();

    config.headers = {
      ...getHeaders(config.url),
    };
    if (authToken != null) {
      config.headers["auth-token"] = authToken;
    }
    if (token != null) {
      config.headers["authorization"] = `Bearer ` + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

axiosInstance.interceptors.response.use(
  (response) => {
    // Return the response directly if successful
    return response;
  },
  async (error) => {
    if (error.response?.status === 403 && !error.config?._retry) {
      error.config._retry = true;

      try {
        const newAccessToken = await getRefreshedAccessToken();
        localStorage.setItem("token", newAccessToken);

        error.config.headers['authorization'] = `Bearer ${newAccessToken}`;
        return axiosInstance.request(error.config);
      } catch (refreshError) {
        console.error("Error during token refresh:", refreshError);
        clearSessionAndShowLogin();
        return Promise.reject(refreshError);
      }
    }

    // For other errors, propagate the error
    return Promise.reject(error);
  }
);

export default axiosInstance;
